import { RefObject } from "react";
import type { RouterProps } from "@reach/router";

export const scrollToElementIfNotCentered = (
  ref: RefObject<HTMLDivElement>,
  scrollOptions: boolean | ScrollIntoViewOptions,
) => {
  const htmlElement = ref.current;
  if (htmlElement) {
    const rect = htmlElement.getBoundingClientRect();
    const isCentered = rect.top >= 0
      && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);

    if (!isCentered) {
      htmlElement.scrollIntoView(scrollOptions);
    }
  }
};

/**
 * see https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/#shouldUpdateScroll
 * */
export const shouldUpdateScroll = ({ routerProps: { location } }: { routerProps: RouterProps }) => {
  const disableScroll = location?.pathname === '/en/faqs/' || location?.pathname === '/fr/faqs/';
  return !disableScroll;
};

export const smoothScrollToElement = (ref: RefObject<HTMLDivElement>) => scrollToElementIfNotCentered(ref, { behavior: 'smooth', block: 'center' });
